// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__aTmeV","container":"styles_container__3DyWr","title":"styles_title__1_1Jf","wrapper":"styles_wrapper__2cyt0","answer":"styles_answer__2rGim"};